<template>
  <transition name="fade">
    <div
      v-if="showSummary"
      class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
    >
      <div
        class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
      >
        <div
          class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
        >
          <p class="text-base">{{ title }}</p>
          <img
            class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
            src="@/assets/icons/cross-white.png"
            @click="close()"
          />
        </div>
        <ve-table :columns="balancesColumns" :tableData="balance"> </ve-table>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DashboardLeaveBalances",
  components: {},
  props: ["timeOffBalance", "showSummary", "title", "close"],
  data() {
    return {
      balancesColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Balance Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Days",
          key: "Days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            row.Days > 0 ? (
              <p class="text-green-500 font-bold text-sm">{row.Days}</p>
            ) : (
              <p class="text-red-500 font-bold text-sm">{row.Days}</p>
            ),
        },
      ],
      balance: [],
    };
  },
  computed: {
    ...mapGetters([]),
  },

  created() {},
  mounted() {},
  watch: {
    // balance: {
    //   handler(newVal) {
    //     if (newVal.length > 0) {
    //       this.formatLeaveTypeStats(this.timeOffBalance);
    //     }
    //   },
    //   immediate: true,
    // },
    timeOffBalance: {
      handler() {
        // Handle updates to the timeOffBalance prop if needed
        this.formatLeaveTypeStats(this.timeOffBalance);
      },
      deep: true, // Watch for changes within the object if timeOffBalance is an object
    },
  },

  methods: {
    formatLeaveTypeStats(stats) {
      // Iterate over the key-value pairs of the stats object and map them to an array of objects
      this.balance = Object.entries(stats[0]).map(([key, value]) => {
        // Split the key at the uppercase letters and join with a space to create the Name property
        const name = key.split(/(?=[A-Z])/).join(" ");
        // Create the Days property with the corresponding value for the key
        const days = value;
        // Return an object with the Name and Days properties
        return { Name: name, Days: days };
      });
    },
  },
};
</script>

<style>
.el-tabs__item.is-top.is-active {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: "#fff" !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #fff;
}

.el-tabs__item.is-top:hover {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
}
</style>
